
import { Constants } from "@/constant/Constants";
import { Config } from "@/data/Config";
import { AppDataType, GameConfigType } from "@/types";
import AbstractVue from "@/views/AbstractVue";
import { gsap } from "gsap";
import { rsort } from "semver";
import { Options } from "vue-class-component";
import { loadGameConfigs, loadGameVersions } from "@/data/Utils";

@Options({})
export default class ConfigSelect extends AbstractVue {
  private configLoaded = false;
  private versions: string[] = [];

  get buildPrefixes(): string[] {
    return this.store.state.buildPrefixes;
  }

  created(): void {
    if (this.parameters.game == null) {
      this.$router.push("/");
      return;
    }

    this.updateConfigs();

    if (this.parameters.game.getConfigs().length >= 1) {
      this.configLoaded = true;
    }
    console.log(this.parameters.game);
  }

  get buildSizeUrl(): string {
    const game = this.parameters.game;
    if (!game || !game.buildPrefix || !game.id || !game.version) return '';
    return `${Constants.AWS_URL}/frontend/${game.buildPrefix}-${game.id}/${game.version}/package/output/build-info.json`;
  }

  openBuildSizeUrl(): void {
    window.open(this.buildSizeUrl,'_blank')
  }

  updateConfigs(): void {
    loadGameConfigs(this.parameters.game, this.$http)
      .then(configs => {
        if (configs.length > 0) {
          this.parameters.game.setGameConfig(configs);
          this.configLoaded = true;
        } else {
          this.configLoaded = false;
          this.$router.push("/");
        }
      });

    this.parameters.game.buildPrefix = this.parameters.game.buildPrefix ?? this.buildPrefixes[0];

    this.updateVersions();
  }

  updateVersions(): void {
    loadGameVersions(this.parameters.game, this.$http)
      .then((versions) => {
        this.versions = versions;
        this.parameters.game.setGameVersions(this.versions);
      });
  }

  selectConfig(config: Config): void {
    console.log(config);
    this.parameters.game.selectedConfig = config;
    this.$router.push("/gametesting");
  }

  beforeEnter(el: HTMLElement): void {
    el.style.opacity = "0";
    el.style.transform = "scale(0)";
  }

  enter(el: HTMLElement, done: () => void): void {
    gsap.to(el, {
      opacity: 1,
      scale: 1,
      duration: 1,
      onComplete: done,
      delay: 0.2 * +el.dataset.index,
    });
  }
}
